import React from 'react';
import { Layout } from 'components/organisms';
import {
  FileSelect, FileUploadForm, Toast, FileUpdateForm
} from 'containers';
import { Title } from 'components/atoms';
import { Modal } from 'components/molecules';
import { useToggle } from 'hooks';
import { useParams, useHistory } from 'react-router-dom';
import { useCopyToClipboard } from 'react-use'
import { PORTAL_WWW } from 'services/constants'
import { toast } from 'react-toastify';

const ThePage = () => {
  const history = useHistory()
  const { subweb, lang, fileId } = useParams();
  const [, copyToClipboard] = useCopyToClipboard();

  const [isOpen, toggle] = useToggle(false)
  const [isOpenUpdateForm, toggleUpdateForm] = useToggle(fileId !== undefined)

  const handleCloseUpdateFormModal = () => {
    toggleUpdateForm()
    history.push(`/${encodeURIComponent(subweb)}/files/${lang}`)
  }

  // open file edit
  React.useMemo(() => {
    if (!isOpenUpdateForm && fileId !== undefined) toggleUpdateForm()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fileId])

  const handleSelect = selectedFile => {
    const { id, title, orginalName: originalName } = selectedFile

    copyToClipboard(`${PORTAL_WWW}/file/${id}`)
    toast.success(
      <Toast
        type="success"
        title={`Link do ficheiro ${originalName} copiado`}
        description={title}
      />
    );
    if (isOpen) toggle()
  }

  return (
    <Layout subtitle="ficheiros" hasSubwebHeader>
      <FileSelect
        onClickUpload={toggle}
        onSelect={handleSelect}
        lang={lang}
        subweb={subweb}
        icon="fal fa-link"
      />
      <Modal isOpen={isOpen} toggle={toggle}>
        <Modal.Top>
          <Title>
            Carregar ficheiro
          </Title>
        </Modal.Top>
        <FileUploadForm
          onSubmit={handleSelect}
          onDiscard={toggle}
          lang={lang}
          subweb={subweb}
        />
      </Modal>

      <Modal isOpen={isOpenUpdateForm} toggle={handleCloseUpdateFormModal}>
        <Modal.Top>
          <Title>
            Editar ficheiro
          </Title>
        </Modal.Top>
        <FileUpdateForm
          onDiscard={handleCloseUpdateFormModal}
          lang={lang}
          subweb={subweb}
          fileId={fileId}
        />
      </Modal>
    </Layout>
  );
};

export default ThePage;
